

export interface GoogleMapsState {
  isLoaded: boolean,
}

export const googleMapsStateinit:GoogleMapsState = {
  isLoaded: false
}